import teacherRoutes from "./teacher.routes";

const routes = [...teacherRoutes];

export default routes;

export * from "./routeNames";
